import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Hardware } from '@app/interfaces/rm/hardware';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HardwareService {
    private baseUrl = environment.api.services.rm + '/hardware';

    constructor(private http: HttpClient) {
    }

    async find(params: {hardwareIds: string[]}): Promise<Hardware[]> {
        return lastValueFrom(this.http.get<Hardware[]>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }
}
